import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import { Cardo } from '@cotyorg/ccx-organism-cardo';
import Carousel from '../Carousel';

const maxCols = 16;

const defaultCardsPerPageMap = {
  xsmall: 1,
  small: 2,
  medium: 3,
  large: 4,
  xlarge: 4,
};

const getColumns = ({ cardsPerPage }) => (
  cardsPerPage === 3 ? 'one-third-width-cell' : maxCols / cardsPerPage
);

const generateBreakpointConfig = R.compose(
  R.fromPairs,
  R.map(([breakpoint, cardsPerPage]) => ([
    breakpoint,
    {
      contentAlignment: {
        horizontal: 'middle',
        vertical: 'bottom',
      },
      gridSetup: {
        image: {
          columns: maxCols,
        },
        content: {
          columns: maxCols,
        },
        card: {
          columns: getColumns({ cardsPerPage }),
        },
      },
    },
  ])),
  R.toPairs,
  R.propOr({}, 'cardsPerPageMap'),
);

const CardoCarousel = ({
  infinite,
  currentBreakpoint,
  cardoData,
  cardoProps,
  carouselProps,
  cardsPerPageMap = defaultCardsPerPageMap,
  imageDecode,
  doNotLazyLoad = true,
}) => {
  const noOfCardsPerPage = R.propOr(1, currentBreakpoint, cardsPerPageMap);
  const breakpointConfig = generateBreakpointConfig({ cardsPerPageMap });

  return (
    <Carousel
      {...carouselProps}
      infinite={infinite}
      isCarouselFullWidth
      isCarouselContentFullWidth
      showPagination={!infinite}
      noPerPage={noOfCardsPerPage}
      pagination={{
        isOverlayed: false,
        ...R.prop('pagination', carouselProps),
      }}
    >
      {
        cardoData.map((data, index) => (
          <Cardo
            key={data.id}
            data={data}
            breakpointConfig={breakpointConfig}
            doNotLazyLoad={doNotLazyLoad}
            imageDecode={imageDecode}
            index={index}
            {...cardoProps}
          />
        ))
      }
    </Carousel>
  );
};

CardoCarousel.propTypes = {
  currentBreakpoint: PropTypes.string.isRequired,
  cardoData: PropTypes.arrayOf(PropTypes.any),
  cardoProps: PropTypes.objectOf(PropTypes.any),
  carouselProps: PropTypes.objectOf(PropTypes.any),
  cardsPerPageMap: PropTypes.shape({
    xsmall: PropTypes.number,
    small: PropTypes.number,
    medium: PropTypes.number,
    large: PropTypes.number,
    xlarge: PropTypes.number,
  }),
  infinite: PropTypes.bool,
  imageDecode: PropTypes.string,
  doNotLazyLoad: PropTypes.bool,
};

export default CardoCarousel;
